module.exports = __webpack_public_path__ + "static/media/shareIcon.06215ed4.svg";